import { motion } from "framer-motion";
import type { Theme } from "../theme";

type InfoModalProps = {
  open: boolean;
  theme: Theme;
  title: string;
  body: string;
  buttonLabel: string;
  onClose: () => void;
};

export function InfoModal({ open, theme, title, body, buttonLabel, onClose }: InfoModalProps) {
  if (!open) {
    return null;
  }

  return (
    <motion.div
      className="info-backdrop"
      role="dialog"
      aria-modal="true"
      aria-label={title}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.18, ease: "easeOut" }}
    >
      <motion.div
        className={`info-card panel panel-${theme}`}
        initial={{ opacity: 0, scale: 0.94, y: 10 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        transition={{ duration: 0.18, ease: "easeOut" }}
      >
        <h2>{title}</h2>
        <p className="info-body">{body}</p>
        <button type="button" className="info-button" onClick={onClose}>
          {buttonLabel}
        </button>
      </motion.div>
    </motion.div>
  );
}
